import GoogleMap from "../components/map";

class Contact {
    constructor(el) {
        if (!el) return;
        
        this.root = el;
        
        this.init();
    }
    
    init() {
        this.tabButtons = this.root.querySelectorAll("[data-tab-button]");
        this.tabContents = this.root.querySelectorAll("[data-tab-content]");
        this.maps = this.root.querySelectorAll("[data-map]");
        this.activeTabContent = null;

        this.events();
        if (this.tabContents.length) {
            this.activeTabContent = this.tabContents[0];
            this.handleTextareaHeight();
        }
        this.initMaps();
    }

    events() {
        if (this.tabButtons.length) {
            this.tabButtons.forEach((element, key) => {
                element.addEventListener('click', () => {
                    this.handleTabButtonClick(element, key)
                })
            });
        }

        window.addEventListener("resize", this.handleTextareaHeight.bind(this));
    }

    handleTabButtonClick(el, key) {
        this.tabButtons.forEach((element, index) => element.classList.remove('-active'));
        this.tabContents.forEach((element, index) => element.classList.add('hidden'));
        el.classList.add('-active');
        this.tabContents[key].classList.remove('hidden');
        this.activeTabContent = this.tabContents[key];

        this.handleTextareaHeight();
    }

    initMaps() {
        if (!this.maps.length) return;
        
        this.maps.forEach(map => {
            new GoogleMap(map);
        })
    }

    handleTextareaHeight() {
        const form = this.activeTabContent.querySelector("form");
        if (!form) return;
        const textareas = form.querySelectorAll("[data-field='textarea']");
        if (!textareas.length) return;
        const firstTextarea = textareas[0];
        firstTextarea.style.height = "";
        
        if (window.innerWidth < 1024) {
            return;
        }

        const parent = firstTextarea.parentElement;
        const children = parent.querySelectorAll("[data-field]");

        let contentHeight = 0;
        children.forEach(el => {
            const rect = el.getBoundingClientRect();
            const parentRect = parent.getBoundingClientRect();

            const bottom = rect.bottom - parentRect.top;
            if (bottom > contentHeight) {
                contentHeight = bottom;
            }
        });
        const parentPossibleHeight = parent.offsetHeight

        if (contentHeight === parentPossibleHeight) return;
        
        const firstTextareaHeight = firstTextarea.offsetHeight;

        firstTextarea.style.height = `${parentPossibleHeight-(contentHeight-firstTextareaHeight)}px`;
    }
}


const sections = document.querySelectorAll("section.contact");
if (sections.length) {
    sections.forEach(element => {
        new Contact(element);
    });
}